export default defineNuxtRouteMiddleware(to =>
{
    const runtimeConfig = useRuntimeConfig();

    if (!runtimeConfig.public.productBuilderEnabled && typeof to.name === 'string' && to.name.startsWith('store-product-builder-templates'))
        return navigateTo({ name: 'store-products' });
});
